enum ZonePlannerModeState {
  Default = "Default",
  EvacuationMode = "EvacuationMode",
  EditMap = "EditMap",
  EditAutoGeneratedTeachAndRepeatPath = "EditAutoGeneratedTeachAndRepeatPath",
  MapRules = "MapRules",
}

export default ZonePlannerModeState;
